import { SiteInformation } from '@/features/games-app-bridge/internal/types/site-information';
import { getConfig } from './get-config';
import { LocaleCode } from '@/i18n/locales';
import { CurrencyCode } from '@/shared/constants/currencies';
import { User } from 'next-auth';
import { pagesRoutes, accountRoutes } from '@/shared/constants/routes';

export const wtExtraBase = {
  countryCode: 'dummy',
  isVerified: false,
  links: {
    account: accountRoutes.PURCHASE_HISTORY,
    login: pagesRoutes.login.href,
    logout: `${pagesRoutes.logout.href}?redirectTo=/local/Library/index.html`,
    cart: pagesRoutes.cart.href,
    checkout: 'dummy',
    purchaseHistory: accountRoutes.PURCHASE_HISTORY,
    updateAccount: accountRoutes.ACCOUNT_DETAILS,
    updateBilling: accountRoutes.PAYMENT_METHODS,
    joinWild: pagesRoutes.joinWild.href,
    unlimitedPlay: pagesRoutes.wildUnlimitedPlay.href,
    webGames: pagesRoutes.onlineGames.href,
    support: pagesRoutes.support.href,
    getGamesApp: pagesRoutes.gamesApp.href,
    register: pagesRoutes.register.href,
  },
  theme: {
    primary: 'dummy',
    secondary: 'dummy',
    textColor: 'dummy',
    labelColor: 'dummy',
    textError: 'dummy',
    fontFamily: 'dummy',
    fontSize: 0,
  },
};

export const buildSiteInformation = (
  user: User | null,
  locale: LocaleCode,
  currency: CurrencyCode,
): SiteInformation => {
  const { gamesAppClientId, clientServiceUrl, awsApiUrl } = getConfig();

  return {
    ...wtExtraBase,
    appId: gamesAppClientId,
    clientServicesUrl: clientServiceUrl,
    apiUrl: awsApiUrl,
    email: user?.email,
    customerGroupName: user?.isWildMember ? 'wild_member' : undefined,
    ums: user?.umsGuid ? user.umsGuid : undefined,
    language: locale,
    activeCurrency: currency,
  };
};
